<template>
  <el-dialog title="重新绑定邀请人" :visible.sync="visible" width="500px" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="用户昵称">
        <el-input v-model="user.nickname" disabled />
      </el-form-item>
      <el-form-item label="当前邀请人ID">
        <el-input v-model="user.inviter_id" disabled />
      </el-form-item>
      <el-form-item label="新邀请人ID" prop="new_inviter_id">
        <el-input
          v-model="form.new_inviter_id"
          type="number"
          placeholder="请输入新邀请人ID"
          clearable
        />
      </el-form-item>
      <el-alert
        title="提示"
        type="warning"
        :closable="false"
        style="margin-top: 10px;"
      >
        重新绑定邀请人后将无法恢复，请谨慎操作。
      </el-alert>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { rebindInviter } from '@/api/user'

export default {
  name: 'RebindInviterDialog',
  data() {
    return {
      visible: false,
      submitting: false,
      user: {},
      form: {
        user_id: 0,
        new_inviter_id: null
      },
      rules: {
        new_inviter_id: [
          { required: true, message: '请输入新邀请人ID', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
                return
              }
              const num = Number(value)
              if (isNaN(num) || num <= 0) {
                callback(new Error('邀请人ID必须大于0'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    open(user) {
      this.user = { ...user }
      this.form.user_id = user.id
      this.form.new_inviter_id = null
      this.visible = true
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // 检查是否绑定自己
          if (this.form.user_id === this.form.new_inviter_id) {
            this.$message.warning('不能绑定自己为邀请人')
            return
          }

          this.submitting = true
          try {
            const res = await rebindInviter(this.form)
            if (res.code === 200) {
              this.$message.success('重新绑定成功')
              this.visible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg || '重新绑定失败')
            }
          } catch (error) {
            this.$message.error(error.message || '重新绑定失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>
